import React from "react";
import ThumbnailVimeo from "./ThumbnailVimeo";
import ThumbnailYouTube from "./ThumbnailYouTube";
import ThumbnailVideo from "./ThumbnailVideo";
import ThumbnailAudio from "./ThumbnailAudio";
import ThumbnailImage from "./ThumbnailImage";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import IspotPlayer from "./IspotPlayer/IspotPlayer";

export default function DraggableThumbnail({ item, setPlaying }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item._id });

  const itemStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const handleSetPlaying = () => {
    setPlaying && setPlaying(item);
  };

  if (!!(item.type && item.fileUrl)) {
    return (
      <div
        style={itemStyle}
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        className={`video-thumbnail`}
      >
        {item.type === "video" && (
          <>
            {item.fileUrl.includes("ispot.tv") && (
              <IspotPlayer
                url={item.fileUrl}
                style={{ pointerEvents: "none" }}
                onClick={() => handleSetPlaying(item)}
              />
            )}
            {item.fileUrl.includes("vimeo") && (
              <ThumbnailVimeo item={item} setPlaying={handleSetPlaying} />
            )}
            {(item.fileUrl.includes("youtube") ||
              item.fileUrl.includes("youtu.be")) && (
              <ThumbnailYouTube item={item} setPlaying={handleSetPlaying} />
            )}
            {item.source === "instagram" && (
              <img
                src={
                  "https://cdn.digitbin.com/wp-content/uploads/How-to-Send-Silent-and-Disappearing-Messages-on-Instagram.png"
                }
                style={{ width: "40px", height: "40px", objectFit: "contain", margin: "auto", display: "block" }}
                onClick={() => handleSetPlaying(item)}
              />
            )}
            {item.source === "twitter" && (
              <img
                src="https://abs.twimg.com/icons/apple-touch-icon-192x192.png"
                style={{ width: "40px", height: "40px", objectFit: "contain", margin: "auto", display: "block" }}
                onClick={() => handleSetPlaying(item)}
              />
            )}
            {item.source === "linkedin" && (
              <img
                src="https://static.licdn.com/aero-v1/sc/h/al2o9zrvru7aqj8e1x2rzsrca"
                style={{ width: "40px", height: "40px", objectFit: "contain", margin: "auto", display: "block" }}
                onClick={() => handleSetPlaying(item)}
              />
            )}
            {!item.fileUrl.includes("ispot.tv") &&
              !item.fileUrl.includes("vimeo") &&
              !item.fileUrl.includes("youtube") &&
              !item.fileUrl.includes("youtu.be") &&
              item.source !== "instagram" &&
              item.source !== "twitter" &&
              item.source !== "linkedin" && (
              <ThumbnailImage item={item} setPlaying={handleSetPlaying} />
            )}
          </>
        )}
        {item.type === "audio" && (
          <ThumbnailAudio item={item} setPlaying={handleSetPlaying} />
        )}
        {(item.type === "image" || item.type === "docs") && (
          <ThumbnailImage item={item} setPlaying={handleSetPlaying} />
        )}
        {item.type === "website" && (
          <ThumbnailImage item={item} setPlaying={handleSetPlaying} />
        )}
        {item.type === "pexels-video" && (
          <ThumbnailVideo item={item} setPlaying={handleSetPlaying} />
        )}
      </div>
    );
  }

  return null;
}
